// extracted by mini-css-extract-plugin
export default {"description":"TasksFormCreate_description__OnSf+","descriptionAssignUsers":"TasksFormCreate_descriptionAssignUsers__m8lmM","allocated":"TasksFormCreate_allocated__ETcxb"};